import React, {Component} from 'react';
import {connect} from 'react-redux';

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {};
}

class CookieConsent extends Component {

    constructor(props) {

        super(props);

        this.state = {
            cookieHTML: ""
        }

        this.cookieRef = React.createRef();

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {

        if (this.state.cookieHTML !== nextState.cookieHTML) {
            return true;
        }

        return false;

    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        const cookie = this.cookieRef.current;
        const scriptTags = cookie.getElementsByTagName('script')
        let script = "";
        for (let n = 0; n < scriptTags.length; n++) {
            // eslint-disable-next-line
            script += scriptTags[n].innerHTML;
        }
        if (scriptTags.length > 0) {
            script += "initializeCookieConsent();";
        }
        if (typeof window.gtag !== 'function') {
            window.gtag = () => {
                window.dataLayer.push(arguments);
            }
        }
        if (script) {
            eval(script);
        }
    }

    componentDidMount() {

        if (document.cookie && document.cookie.indexOf('KD_GDPR_CC') >= 0) {

            const cookieObject = JSON.parse(
                decodeURIComponent(
                    document.cookie
                        .substr(
                            document.cookie.indexOf('KD_GDPR_CC') + 'KD_GDPR_CC'.length + 1
                        )
                        .split('; ')[0]
                )
            );
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'KD_GDPR_CC_consent',
                KD_GDPR_CC: {
                    consents: cookieObject.consents,
                },
            });

            if (cookieObject.gtmConsents) {
                window.gtag('consent', 'update', cookieObject.gtmConsents['de'] || cookieObject.gtmConsents);
                window.dataLayer.push({"event": "gtm.init_consent"});
            }

        } else {

            let requestHeaders = new Headers()
            requestHeaders.append('content-type', 'application/json');

            let fetchOptions = {method: "GET", headers: requestHeaders, credentials: "include"}

            fetch("https://www.mittwald.de/api/kd-gdpr-cc?siteNode=%7B%22contentRepositoryId%22%3A%22default%22%2C%22workspaceName%22%3A%22live%22%2C%22dimensionSpacePoint%22%3A%7B%22language%22%3A%22de%22%7D%2C%22aggregateId%22%3A%22472a5a80-d0a7-4aa3-8210-48afe1cc430c%22%7D", fetchOptions).catch(error => {
            }).then((response, error) => {

                if (!response) {
                    return;
                }

                response.json().catch(error => {

                }).then((json, error) => {

                    if (json["needsRenew"]) {
                        this.setState({
                            cookieHTML: json["html"]
                        })
                    }
                })
            });

        }
    }

    render() {
        return (
            <div ref={this.cookieRef} className={"cookie-consent"} dangerouslySetInnerHTML={{__html: this.state.cookieHTML}}/>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CookieConsent);



/** WEBPACK FOOTER **
 ** ./src/components/CookieConsent.js
 **/